// src/app/auth/auth.service.ts
import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {Observable, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {LOGIN_MUTATION_MKT, UPDATEPASSWORDBYEMAIL} from '../graphql/graphql.queris';
import {Router} from "@angular/router";
import {jwtDecode} from "jwt-decode";


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private tokenKey = '';
  dataUser: any[] = [];

  constructor(private apollo: Apollo, private router: Router) {}

  login(email: string | null | undefined, pass: string | null | undefined): Observable<{
    access_token: string;
    user: any
  }> {
    // console.log( email, pass);
    return this.apollo.mutate<{ loginMkt: { access_token: string, user: any } }>({
      mutation: LOGIN_MUTATION_MKT,
      variables: { email, pass }
    }).pipe(
      map(result => {
        if (!result.data) {
          throw new Error('No data returned from login mutation');
        }
        return result.data.loginMkt;
      }),
      tap(response => {
        if (response && typeof localStorage !== 'undefined') {
          if (!response.user.status) {
            return
          }
          this.dataUser = response.user;
          localStorage.setItem(this.tokenKey, response.access_token);
        }
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }

  logout() {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(this.tokenKey);
      this.router.navigate(['/']);
    }
  }

  getToken(): string | null {
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem(this.tokenKey);
    }
    return null;
  }

  getDatosUser() {
    const token = this.getToken();
    if (token) {
      return JSON.parse(atob(token.split('.')[1]));
    }
    return null
  }

  isTokenExpired(): boolean {
    const token = this.getToken();
    if (!token) {
      return true;
    }
    const decodedToken: any = jwtDecode(token);
    if (decodedToken.exp === undefined) {
      return true;
    }
    const expirationDate = new Date(0);
    expirationDate.setUTCSeconds(decodedToken.exp);
    return expirationDate < new Date();
  }

  getCurrentUser() {
    const token = this.getToken();
    if (token) {
      return JSON.parse(atob(token.split('.')[1]));
    }
    return null;
  }

  updatePassword(email: string, passwordOld: string, passwordNew: string): Observable<any> {
    return this.apollo.mutate({
      mutation: UPDATEPASSWORDBYEMAIL,
      variables: { email, passwordOld, passwordNew },
      context: {
        headers: {
          Authorization: `Bearer ${this.getToken()}`
        }
      },
      fetchPolicy: 'network-only'
    });
  }


  isLoggedIn(): boolean {
    return !!localStorage.getItem('access_token');
  }
}
